export const DEVELOPMENT = 'development';
export const PRODUCTION = 'production';
